import React, {useEffect, useState} from "react"


const FilterInput = (props) => {
    const [focused, setFocused] = useState(false);
    const handleLabelClick = () => {
        setFocused(true);
      };
    

    
      const handleInputBlur = () => {
        if (!props.defaultValue) {
          setFocused(false);
        }
      };

    return (
        <div
            className={`form-focus ${(focused || props.value || props.defaultValue )&& " focused"} `
            }
          >
            <input
              type="text"
              className="form-control floating"
              {...props}
              // value={props.value}
              // defaultValue={defaultValue}
              onFocus={handleLabelClick}
              onBlur={handleInputBlur}
              // onChange={onChange}
            />
            <label className="focus-label" onClick={handleLabelClick}>
              {props.label}
            </label>
          </div>
    )
}

export default FilterInput